<script>
    import { toastMessage } from "/stores/toast.js";
</script>

{#if $toastMessage}
    <div class="toast">{$toastMessage}</div>
{/if}

<style>
    .toast {
        position: fixed;
        top: 32px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #323232;
        color: #fff;
        padding: 12px 24px;
        border-radius: 6px;
        font-size: 14px;
        z-index: 10000;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
        animation: fadeIn 0.2s ease;
    }

    @keyframes fadeIn {
        from { opacity: 0; transform: translateX(-50%) translateY(-8px); }
        to { opacity: 1; transform: translateX(-50%) translateY(0); }
    }
</style>
